import React from "react";
import { Datagrid, TextField } from "react-admin";

import { AppList } from "components/list/AppList";
import { ScrollingWrapper } from "components/ScrollingWrapper";
import { DateTimeField } from "components/fields/DateFormatField";
import { SelectEnumField } from "components/fields/SelectEnumField";
import { ThirdPartyField } from "components/fields/ThirdPartyField";
import { AppSecretType } from "entities/AppSecretType";

import { AppSecretRowActions } from "../AppSecretRowActions";


const defaultSort = { field: "id", order: "DESC" };


export const AppSecretsList = (props) => (
	<AppList
		{...props}
		sort={defaultSort}
		exporter={false}
		bulkActionButtons={false}
	>
		<ScrollingWrapper>
			<Datagrid rowClick="show">
				<TextField source="id" />
				<ThirdPartyField source="oauth2_client_id" />
				<SelectEnumField source="type" enumObj={AppSecretType} enumName="app_secret_type" />
				<DateTimeField source="created_at" withLocalTimeZone />
				<AppSecretRowActions />
			</Datagrid>
		</ScrollingWrapper>
	</AppList>
);
